export const environment = {
  production: true,
  staging: true,
  hmr: false,
  SENTRY_ENABLED: false,
  SENTRY_DSN: '',
  HYPERDX_ENABLED: true,
  HYPERDX_API_KEY: '958c6da1-17b5-46e7-8a6d-21d759507d4b',
  HYPERDX_INGEST_URL: 'https://ingest.aspik.is',
}

export const SERVER_URL = 'https://oa-staging-backend.aspik.is'
export const ORGANIZATION_TITLE = 'ASPIK-DEV'
export const ORGANIZATION_SUBTITLE = 'Staging'
